import React from 'react';
import { XIcon } from 'lucide-react';
import { Section } from './Shared';
import { KanjiBackdrop } from './Ornaments';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <Section className="max-w-4xl" data-id="element-241" data-mp="26z7muryed7ce">
      <KanjiBackdrop glyphs={['痛', '疾', '虛', '滯', '亂']} data-id="element-242" data-mp="26y60vsfuf0fw" />
      <div className="text-center" data-id="element-243" data-mp="2bwqzjnfg5c28">
        <p className="font-kanji text-xl text-brand-goldDark/70" aria-hidden="true" data-id="element-244" data-mp="2bvoc5phc1rr2">
          問
        </p>
        <h2 className="mt-2 font-display text-3xl font-bold leading-tight text-brand-ink md:text-5xl" data-id="element-245" data-mp="1xzubtuumkapk">
          ¿Cuántos pacientes más vas a atender sin el sistema visual que tu
          práctica merece?
        </h2>
        <div className="mx-auto mt-7 max-w-2xl space-y-4 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-246" data-mp="1syn57z47xhkh">
          <p data-id="element-247" data-mp="3idupeo8qw7it">
            Sos terapeuta de acupuntura o digitopuntura. Invertiste años en tu
            formación. Conocés los meridianos, entendés el Qi, sabés dónde están
            los puntos.
          </p>
          <p data-id="element-248" data-mp="1z05bvdw6lb3u">
            Creés en el poder de la medicina ancestral. En que el cuerpo tiene
            todas las respuestas. En que una aguja en el lugar correcto cambia
            todo.
          </p>
          <p className="font-semibold" data-id="element-249" data-mp="27t8k97ryyxrm">
            Pero hay algo que ningún libro de medicina china te dio:
          </p>
          <p className="font-semibold text-brand-forest" data-id="element-250" data-mp="23sopgauvc68n">
            Un sistema visual clínico, rápido y preciso para usar dentro de la
            sesión.
          </p>
          <p className="text-brand-muted" data-id="element-251" data-mp="1b3hoz6but6kr">
            No para estudiar. No para repasar. Para usar mientras el paciente
            está en la camilla.
          </p>
          <p className="font-display text-lg italic text-brand-burgundy" data-id="element-252" data-mp="1p04p1hz3scuw">
            Y esa diferencia la sentís cada vez que:
          </p>
        </div>
      </div>
      <div className="paper-card mt-10 rounded-sm border border-brand-burgundy/30 p-6 shadow-[0_10px_30px_rgba(44,38,32,0.08)] md:p-9" data-id="element-253" data-mp="30g32dy1bdl1x">
        <h3 className="flex items-center gap-2 font-serif text-base font-bold uppercase tracking-[0.06em] text-brand-ink md:text-lg" data-id="element-254" data-mp="1t55bwc0kv3y2">
          <XIcon className="h-5 w-5 text-brand-burgundy" aria-hidden="true" data-id="element-255" data-mp="1y3ghubnr4ub0" />
          Lo que pasa sin el Atlas Ancestral de Acupuntura™
        </h3>
        <span className="fret-rule mt-4 block w-full opacity-50" aria-hidden="true" data-id="element-256" data-mp="223qta3ubccx9" />
        <ul className="mt-6 space-y-4" data-id="element-257" data-mp="2744xfassn2q0">
          {painPoints.map(point => <li key={point} className="flex gap-3 text-sm leading-relaxed text-brand-text md:text-base" data-id="element-258" data-mp="1afyr8jg8429m">
              <XIcon className="mt-1 h-4 w-4 shrink-0 text-brand-burgundy" aria-hidden="true" data-id="element-259" data-mp="1jfc13d89esuv" />
              {point}
            </li>)}
        </ul>
      </div>
      <p className="mt-10 text-center font-display text-2xl font-bold italic text-brand-burgundy md:text-3xl" data-id="element-260" data-mp="qr7rwhqhbxnf">
        ¿Y si esta fuera la última sesión que trabajás sin un atlas visual
        clínico completo?
      </p>
    </Section>;
}